import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import {
  colorSurfaceLightGray,
  colorWhite,
  shadowImageGalleryNavPill,
  skeletonShimmerGradient,
} from '../style-settings'

export const useItemImageSliderStyles = makeStyles((theme: Theme) =>
  createStyles({
    slider: {
      '& .image-gallery': {
        backgroundColor: colorWhite,
      },
      '& .image-gallery-slide-wrapper': {
        borderRadius: 8,
        overflow: 'hidden',
      },
      '& .image-gallery-thumbnails': {
        paddingTop: theme.spacing(1.5),
      },
      '& .image-gallery-thumbnail': {
        borderRadius: 6,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.divider}`,
      },
      '& .image-gallery-thumbnail.active, & .image-gallery-thumbnail:focus': {
        border: `2px solid ${theme.palette.primary.main}`,
      },
      '& .image-gallery-left-nav, & .image-gallery-right-nav': {
        padding: theme.spacing(1),
        filter: 'none',
        /* gallery SVG uses stroke=currentColor; default theme color is white → invisible on our white pill */
        color: theme.palette.text.primary,
      },
      '& .image-gallery-left-nav .image-gallery-svg, & .image-gallery-right-nav .image-gallery-svg':
        {
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: colorWhite,
          boxShadow: shadowImageGalleryNavPill,
        },
    },

    '@keyframes itemImageSliderLoading': {
      '0%': {
        backgroundPosition: '-250px 0',
      },
      '100%': {
        backgroundPosition: '250px 0',
      },
    },
    imageArea: {
      overflow: 'hidden',
      position: 'relative',
    },
    imageAreaPublic: {
      background: colorSurfaceLightGray,
    },
    imageAreaOwnerLoading: {
      background: skeletonShimmerGradient,
      animationDuration: '5s',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
      animationName: '$itemImageSliderLoading',
      animationTimingFunction: 'linear',
    },
    imgBgBlock: {
      width: '100%',
      position: 'relative',
      display: 'block',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      zIndex: 1,
    },
    imageHolder: {
      width: '100%',
      position: 'relative',
      paddingBottom: '75%',
      backgroundColor: theme.palette.common.white,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
    },
    imageThumb: {
      paddingBottom: '50%',
      backgroundColor: theme.palette.common.white,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
  })
)
